import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getActivityInitialData } from './api';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';
import { QueryKey } from '@behavior/QueryKey';

type UseQueryOptionsKeys = Pick<QueryObserverOptions, 'enabled' | 'retry' | 'onSuccess'>;

export default function useActivityInitialData(
  isCreationMode: boolean,
  options?: UseQueryOptionsKeys
) {
  const { t } = useTranslation();
  const { data: initialData, isFetching } = useQuery<ActivityInitialDataResponse>(
    [QueryKey.ACTIVITY_INTIAL_DATA],
    () => getActivityInitialData(isCreationMode),
    {
      enabled: true,
      onError: (error: any) => {
        toast.error(t('message.title.error.get.activity') + error.message);
      },
      ...options,
    }
  );

  return { initialData, isFetching, getActivityInitialData };
}
